import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_navBar = _resolveComponent("navBar")!
  const _component_panel = _resolveComponent("panel")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    class: "page-header",
    gutter: 10
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        class: "header-item",
        xs: 0,
        sm: 3
      }, {
        default: _withCtx(() => [
          _createVNode(_component_logo)
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        class: "header-item",
        xs: 12,
        sm: 17
      }, {
        default: _withCtx(() => [
          _createVNode(_component_navBar)
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        class: "header-item",
        xs: 12,
        sm: 4
      }, {
        default: _withCtx(() => [
          _createVNode(_component_panel)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}